export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-de_de.c94e9df8.png";